class FeaturedHomeMulticolumn extends HTMLElement {
  constructor() {
		super()
		this.selectors = {
          selected: ['.active'],
          contents: ['.column-slider'],
          info: ['.multicolumn-slider-info']
		}
		this.domNodes = queryDomNodes(this.selectors, this)
		this.prevIndex = 0
        if(this.domNodes.contents[0])
          this.domNodes.contents[0].classList.add('active')
        console.log(this.domNodes);
        this.domNodes.info[0].classList.add('active')
        //document.querySelector(".multicolumn-slider-info[data-index='0']").classList.add('active')
        document.querySelector('.f-multicolumn button.next').classList.add('active');


        document.querySelector('.f-multicolumn button.next').addEventListener('click', (event) => this.handleChange(event, this.prevIndex))
        document.querySelector('.f-multicolumn button.previous').addEventListener('click', (event) => this.handleChange(event, this.prevIndex))
	}

    handleChange(evt, prevIndex) {
        let direction = 1
        if(evt.currentTarget.classList.contains('previous'))
          direction = -1

        console.log(prevIndex);

        //console.log(document.querySelector(".column-slider[data-index='"+this.prevIndex+"']"))

        if(document.querySelector(".column-slider[data-index='"+(this.prevIndex+direction)+"']")) {
          document.querySelector(".column-slider[data-index='"+this.prevIndex+"']").classList.remove('active')
          document.querySelector(".multicolumn-slider-info[data-index='"+this.prevIndex+"']").classList.remove('active')
  
          document.querySelector(".column-slider[data-index='"+(this.prevIndex+direction)+"']").classList.add('active')
          document.querySelector(".multicolumn-slider-info[data-index='"+(this.prevIndex+direction)+"']").classList.add('active')

          if(document.querySelector(".column-slider[data-index='"+((prevIndex+direction)-1)+"']")) {
            document.querySelector('.f-multicolumn button.previous').classList.add('active');
          } else {
            document.querySelector('.f-multicolumn button.previous').classList.remove('active');
          }

          if(document.querySelector(".column-slider[data-index='"+((prevIndex+direction)+1)+"']")) {
            document.querySelector('.f-multicolumn button.next').classList.add('active');
          } else {
            document.querySelector('.f-multicolumn button.next').classList.remove('active');
          }
          setTimeout(() => {
    			this.prevIndex = (prevIndex+direction)
    		}, 300)
        }


		

	}

}

customElements.define('featured-home-multicolumn', FeaturedHomeMulticolumn)
